import { LoadingProps } from "../typings/ViewTypes";
import {Updater,SplitLayout} from "@npd-ng/adp-component-library";
import { IADPState } from "../typings";
import {useSelector , useDispatch} from "react-redux";
import { useIPCBridge } from "../hooks/useIPCBridge";
import { useDedupEffect } from "../hooks/useDedupEffect";
import { createSetViewAction } from "../state/reducer";

export const RedirectionView = (props: {url: string, join: "&" | "?",redirectParamaters?:object}) => {
  const {setKioskMode} = useIPCBridge();
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  );
  const loadingProps: LoadingProps = {
    title: state.currentLanguageContent?.loadAssessment.title || "",
    message: state.currentLanguageContent?.loadAssessment.message || "",
    subTitle: "",
    spinnerAlt:state.currentLanguageContent?.imageAltText.verifyingIcon as string
  };
  function redirectToSCI(){
    let params: any = {
      adpLaunchId: state.appState.appLaunchId,
      setupcode: state.sessionState.schoolDetails?.setupCode,
      deviceId: state.deviceState.deviceId,
      locale: state.sessionState.schoolDetails?.isPR ? "es" :"en",
      version: state.appState.releaseVersion,
      assessmentMode: state.sessionState.selectedAssessmentMode,
      versionColors: state.appState.releaseColors.map(item => item.replace('#','')), // # need to be removed to prevent params from being unreadable
      borderColors: state.appState.releaseBorder.map(item => item.replace('#','')), // # need to be removed to prevent params from being unreadable
      schoolName: state.sessionState.schoolDetails?.location,
      deviceType: state.deviceState.deviceType
  };
  if(props?.redirectParamaters)params = {...params,...props.redirectParamaters}
    const url = `${props.url}${props.join}`;
    if(!url || url===""){
      dispatch(createSetViewAction("FailureView"));
    }
    else {
      setTimeout(()=>{
        setKioskMode()
          window.location.replace(`${url}${Object.keys(params).map(key => {
             return `${key}=${params[key]}`
         }).join('&')}`);
    },500)
    }
}
useDedupEffect(()=>{
  redirectToSCI();
},[]); 
  return (
    <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string}>
      <Updater {...loadingProps} type="wait" />
    </SplitLayout>
  )
}


